import React from 'react';
import DelBox from '../comps/DelBox';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";

// --- PDF Generation Imports ---
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import QRCode from 'qrcode';
import { toast } from 'react-toastify'; // Used for notifications

const TestParams = () => {
    
           const [image, setImage] = useState('')
              const [isAdmin , setIsAdmin] = useState('')
           const [watermarkImage, setWatermarkImage] = useState('');
    const [formData, setFormData] = useState({
        l1: [],
        cat_type: 'department',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        from: '',
        to: '',
        isAlert: false,
    });
    const [ldata, setLdata] = useState(null);
    const [editItem, setEditItem] = useState(null);
    
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
           const userData = JSON.parse(sessionStorage.getItem("ldata"));
  const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
           fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('from', formData.from ? formData.from + " 00:00:00" : "");
            fd.append('to', formData.to ? formData.to + " 23:59:59" : "");
            fd.append('lab_reg_user', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListUrl, fd, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

                console.log("this is gett  " + JSON.stringify(response.data));
                if (response.data.status) {
                    var records = response.data.records;
                    // Ensure that the nested 'tests' data is parsed from JSON string to object
                    if (records && records.length > 0) {
                        const completedRecords = records.filter(rec => rec.lab_reg_status  === "Completed");
                        const parsedRecords = completedRecords.map(rec => ({
                            ...rec,
                            tests: typeof rec.tests === 'string' ? JSON.parse(rec.tests) : rec.tests
                        }));
                        setFormData(prev => ({ ...prev, l1: parsedRecords }));
                    } else {
                        setFormData(prev => ({ ...prev, l1: [] }));
                    }
                }
            } catch (error) {
                toast.error("Failed to fetch reports.");
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const delItem = async (editItem) => {
        const fd = new FormData();
        fd.append('test_report_id', editItem.test_report_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delTestReportUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data.status) {
                toast.success("Report deleted successfully!");
                initData();
            } else {
                toast.error("Failed to delete report.");
            }
        } catch (error) {
            toast.error("An error occurred while deleting.");
        }
    };

const get_tst_name = (tests) => {
    var name = [];
    if (tests != null && tests !== undefined && tests.length > 0) {
        for (var x = 0; x < tests.length; x++) {
            name.push(tests[x].lab_item_test_name);
        }
    }
    return name.join(" || ");
};


    useEffect(() => {
        initData();
    }, []); // Fetch data on component mount

    // ===================================================================
    // --- PDF Generation Functions ---
    // ===================================================================

    const isAbnormal = (result, normalRange, gender) => {
        if (!result || !normalRange) return false;
        
        const numResult = parseFloat(result);
        if (isNaN(numResult)) return false;

        let rangeStr = normalRange;

        if (normalRange.includes("M:") && gender) {
            const genderChar = gender.charAt(0).toUpperCase();
            const ranges = normalRange.split(' ');
            const relevantRange = ranges.find(r => r.startsWith(genderChar + ":"));
            if (relevantRange) {
                rangeStr = relevantRange.substring(2);
            }
        }

        const rangeParts = rangeStr.match(/(\d+\.?\d*)-(\d+\.?\d*)/);
        if (rangeParts && rangeParts.length === 3) {
            const lower = parseFloat(rangeParts[1]);
            const upper = parseFloat(rangeParts[2]);
            return numResult < lower || numResult > upper;
        }
        return false;
    };

    const get_param_val = (param) => {
        if (param.test_param_type === "Numeric") {
            return `${param.test_param_from_range} - ${param.test_param_to_range}`;
        }
        return param.test_param_from_range || "Yes / No";
    };


        const fetchConfigData = async () => {
            try {
              const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
              );
        
              if (res.data.status) {
                const data = res.data;
        // console.log("Config Data:", JSON.stringify(data.header_logo));
                setImage(data.header_logo);
                setWatermarkImage(data.logo || ''); // Set watermark image if available
           
            } 
        }
            catch (err) {
              console.error("Error fetching config:", err);
            }
          };
        
          useEffect(() => {
            fetchConfigData()
          });
         
        
        //   console.log("formData:", JSON.stringify(formData));
        
        
          // Function to convert an image URL to a Base64 string
        const imageUrlToBase64 = async (url) => {
          // Check if the URL is valid in the first place
          if (!url) {
            console.error("Image URL is empty or invalid.");
            return null;
          }
        
          try {
            const response = await fetch(url);
            if (!response.ok) {
                console.error(`Failed to fetch image. Status: ${response.status} ${response.statusText}`);
                return null;
            }
            
            const blob = await response.blob();
        
            // **IMPORTANT CHECK**: This ensures the downloaded file is an image.
            if (!blob.type.startsWith('image/')) {
              console.error(`The provided URL did not point to an image. It pointed to a file of type: ${blob.type}`);
              return null;
            }
        
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            });
          } catch (error) {
            console.error("Error fetching or converting image:", error);
            return null;
          }
        };

        const addHeaderAndWatermark = async (doc) => {
            // ===== Watermark =====
            const watermarkBase64 = await imageUrlToBase64(watermarkImage);
            if (watermarkBase64) {
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();
                const wmWidth = 120;
                const wmHeight = 120;
                const wmX = (pageWidth - wmWidth) / 2;
                const wmY = (pageHeight - wmHeight) / 2;
                doc.setGState(new doc.GState({ opacity: 0.08 }));
                doc.addImage(watermarkBase64, 'PNG', wmX, wmY, wmWidth, wmHeight);
                doc.setGState(new doc.GState({ opacity: 1 }));
            }
        
            // ===== Header Image =====
            const headerImageBase64 = await imageUrlToBase64(image);
            if (headerImageBase64) {
                const pageWidth = doc.internal.pageSize.getWidth();
                const imgHeight = 30;
                doc.addImage(headerImageBase64, 0, 0, pageWidth, imgHeight);
            } else {
                doc.text("Header Image Not Available", 15, 20);
            }
        
         
        };
    const generateReportPdf = async (patientData, testsToPrint, impression) => {
        // toast.info("Generating PDF, please wait...", { autoClose: 2000 });
        const doc = new jsPDF();
         const pageHeight = doc.internal.pageSize.getHeight();
  await addHeaderAndWatermark(doc);
        
        try {
            const qrCodeDataURL = await QRCode.toDataURL(patientData.lab_reg_id);
            doc.addImage(qrCodeDataURL, 'PNG', 170, 35, 25, 25);
        } catch (err) {
            console.error('Failed to generate QR code', err);
        }
        
        // doc.setLineWidth(0.5);
        // doc.line(14, 42, 196, 42);

        // --- 2. Patient Details ---
        let yPos = 40;
        const leftColLabel = 14, leftColValue = 50, rightColLabel = 105, rightColValue = 140;
        doc.setFontSize(10);
        
        doc.setFont('helvetica', 'bold'); doc.text("UHID", leftColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(`: ${patientData.lab_reg_uhid}`, leftColValue, yPos);
        doc.setFont('helvetica', 'bold'); doc.text("Registration Id", rightColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(`: ${patientData.lab_reg_id}`, rightColValue, yPos);
        yPos += 6;

        doc.setFont('helvetica', 'bold'); doc.text("Patient Name", leftColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(`: ${patientData.lab_reg_name}`, leftColValue, yPos);
        doc.setFont('helvetica', 'bold'); doc.text("Registered On", rightColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(`: ${patientData.test_report_datetime.split(' ')[0]}`, rightColValue, yPos);
        yPos += 6;
        
        doc.setFont('helvetica', 'bold'); doc.text("Age / Gender", leftColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(`: ${patientData.lab_reg_age_year}Y / ${patientData.lab_reg_gender}`, leftColValue, yPos);
        doc.setFont('helvetica', 'bold'); doc.text("Reported On", rightColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(`: ${patientData.test_report_datetime.split(' ')[0]}`, rightColValue, yPos);
        yPos += 6;

        doc.setFont('helvetica', 'bold'); doc.text("Collected At", leftColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(": SHRC", leftColValue, yPos);
        doc.setFont('helvetica', 'bold'); doc.text("Printed On", rightColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(`: ${new Date().toISOString().split('T')[0]}`, rightColValue, yPos);
        yPos += 6;

        doc.setFont('helvetica', 'bold'); doc.text("Sample Collected By", leftColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(": SHRC", leftColValue, yPos);
        doc.setFont('helvetica', 'bold'); doc.text("Referred By", rightColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(`: ${patientData.lab_reg_referral || 'N/A'}`, rightColValue, yPos);
        yPos += 6;
        
        doc.setFont('helvetica', 'bold'); doc.text("Sample Collected On", leftColLabel, yPos);
        doc.setFont('helvetica', 'normal'); doc.text(`: ${patientData.test_report_datetime.split(' ')[0]}`, leftColValue, yPos);
        yPos += 12;

        console.log("Patient Data:", JSON.stringify(patientData));
        // --- 3. Report Table Section ---
         // Section Header
        doc.setFillColor(122, 228, 213);
        doc.rect(14, yPos - 5, 182, 8, 'FD');
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);
        const centerX = 14 + 182 / 2;
        doc.text(patientData.test_name, centerX, yPos, { align: 'center' });
        yPos += 8;


    const allTestRows = [];
    
    // Check if testsToPrint is an array
    if (Array.isArray(testsToPrint)) {
        testsToPrint.forEach(test => {
            allTestRows.push([
                test.test_report_inv_name,
                test.test_report_inv_result,
                test.test_report_inv_units || '',
                test.test_report_inv_range || '',
                test.test_report_inv_method || "Standard Method"
            ]);
        });
    } else {
        allTestRows.push(["No test data available", "", "", "", ""]);
    }

        
      autoTable(doc, {
                 startY: yPos,
                 head: [["TEST NAME", "RESULT", "UNITS", "NORMAL RANGES", "METHOD"]],
                 body: allTestRows,
                 theme: 'plain',
                 headStyles: { fillColor: [122, 228, 213], textColor: 0, fontStyle: 'bold' },
                 styles: { fontSize: 9, cellPadding: 2, valign: 'middle' },
                 columnStyles: {
                     0: { cellWidth: 50 },
                     1: { cellWidth: 25, halign: 'center' },
                     2: { cellWidth: 25, halign: 'center' },
                     3: { cellWidth: 42 },
                     4: { cellWidth: 'auto' }
                 },
                 margin: { left: 14, right: 14 }
             });
        
        yPos = doc.lastAutoTable.finalY + 6;

        // Impression Box
        let impressionText = testsToPrint.impression || "-";
        let splitImpression = doc.splitTextToSize(impressionText, 182);
        let impressionBoxHeight = (splitImpression.length * 4) + 10;

        // Page Break Check Before Impression
        if (yPos + impressionBoxHeight > pageHeight - 40) {
            doc.addPage();
            await addHeaderAndWatermark(doc);
            // yPos = printPatientDetails(doc, patient, 40);
        }

        doc.rect(12, yPos, 186, impressionBoxHeight);
        doc.setFontSize(9).setFont('helvetica', 'bold');
        doc.text(`Impression:`, 14, yPos + 6);
        doc.setFontSize(8).setFont('helvetica', 'normal');
        doc.text(splitImpression, 14, yPos + 12);
        yPos += impressionBoxHeight + 6;

        // Notes Box
        let notesText = testsToPrint.notes || "-";
        let splitNotes = doc.splitTextToSize(notesText, 182);
        let notesBoxHeight = (splitNotes.length * 4) + 10;

        if (yPos + notesBoxHeight > pageHeight - 40) {
            doc.addPage();
            await addHeaderAndWatermark(doc);
            // yPos = printPatientDetails(doc, patient, 40);
        }

        doc.rect(12, yPos, 186, notesBoxHeight);
        doc.setFontSize(9).setFont('helvetica', 'bold');
        doc.text(`Notes:`, 14, yPos + 6);
        doc.setFontSize(8).setFont('helvetica', 'normal');
        doc.text(splitNotes, 14, yPos + 12);
        yPos += notesBoxHeight + 10;
    

    // ==== Signature on Last Page Only ====
    const finalY = pageHeight - 30;
    doc.line(140, finalY, 196, finalY);
    doc.setFontSize(10);
    doc.text("Authorized Signatory", 196, finalY + 5, { align: 'right' });

           // ==== Output ====
    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
    };

const handlePrintReport = async (reportItem) => {
    console.log("Printing report:", reportItem);
    
    if (reportItem.items && Array.isArray(reportItem.items)) {
        // Extract test items and patient data
        const testsToPrint = reportItem.items;
        const patientData = {
            ...reportItem,
            ...reportItem.lab_dt
        };
    
        
        await generateReportPdf(
            patientData, 
            testsToPrint, 
            reportItem.test_report_impression
        );


    } else {
        toast.error("No test items found for this report");
    }
};

// ===================================================================
// --- UPDATED get_tst_name function ---
// ===================================================================
// const get_tst_name = (items) => {
//     if (!items || !Array.isArray(items) return "N/A";
//     return items.map(item => item.test_report_inv_name).join(", ");
// };

 useEffect(() => {
    const today = new Date().toISOString().split('T')[0]; // yyyy-mm-dd format
    setFormData(prev => ({
      ...prev,
      from: today,
      to: today,
    }));

    // If you want, you can also call your data fetching here to load initial data filtered by today's date.
  }, []);
const filteredList = formData.l1.filter(item => {
  const matchesSearch = formData.search_key.trim() === "" || 
    (`${item.lab_reg_uhid}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
     `${item.lab_reg_id}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
     `${item.lab_reg_name}`.toLowerCase().includes(formData.search_key.toLowerCase())
    );

  // Parse item date and compare
  const itemDate = new Date(item.lab_reg_date); // replace with actual date field
  const fromDate = formData.from ? new Date(formData.from) : null;
  const toDate = formData.to ? new Date(formData.to) : null;

  const matchesDate = (!fromDate || itemDate >= fromDate) && (!toDate || itemDate <= toDate);

  return matchesSearch && matchesDate;
});


    console.log("Filtered List:", JSON.stringify(filteredList));

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="orderList">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">My Reports</h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        {/* Other buttons here */}
                                    </div>
                                </div>
                            </div>
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <form>
                                    <div className="row g-3">
                                        <div className="col-md-2">
                                            <label className="form-label">From</label>
                                            <input className="form-control" type="date" name="from" onChange={handleChange} value={formData.from} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">To</label>
                                            <input className="form-control" type="date" name="to" onChange={handleChange} value={formData.to} />
                                        </div>
                                          <div className="col-md-3">

                                                <button type="button" onClick={initData} className="btn btn-success ms-2 d-none" style={{marginTop: "30px"}}>Search</button>
                                          </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Search</label>
                                            <div className="search-box" style={{ display: "flex" }}>
                                                <input className="form-control search" placeholder="Search by Name, UHID, Reg No..." type="text" name="search_key" onChange={handleChange} value={formData.search_key} />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="card-body pt-0">
                                <div className="table-responsive table-card mb-1">
                                    <table className="table table-nowrap align-middle" id="orderTable">
                                        <thead className="text-muted table-light">
                                            <tr className="text-uppercase">
                                                <th scope="col" style={{ width: "25px" }}><div className="form-check"><input className="form-check-input" id="checkAll" type="checkbox" /></div></th>
                                                <th>SI No.</th>
                                                <th>UHID No</th>
                                                <th>Reg No</th>
                                                <th>Patient</th>
                                                <th>Referred Doctor</th>
                                                <th>Test Details</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
 {filteredList && filteredList.length > 0 ? (
  filteredList.map((item, index) => (
    <tr key={item.lab_reg_id}>
      <th scope="row">
        <div className="form-check">
          <input className="form-check-input" type="checkbox" />
        </div>
      </th>
      <td>{index + 1}</td>
      <td>{item.lab_reg_uhid}</td>
      <td>{item.lab_reg_id}</td>
      <td>
        {item.lab_reg_name_title} {item.lab_reg_name}
        <br />
        <small>
          <strong>Age:</strong> {item.lab_reg_age_year}y {item.lab_reg_age_month}m {item.lab_reg_age_day}d
          <br />
          <strong>Gender:</strong> {item.lab_reg_gender}
          <br />
          <strong>Mobile:</strong> {item.lab_reg_mobile}
        </small>
      </td>
      <td>{item.lab_reg_referral}</td>

      {/* ✅ Tests ka naam show karo */}
      <td>
        {item.tests && item.tests.length > 0 ? (
          item.tests.map((t, i) => (
            <span key={i}>
              {t.lab_item_test_name}
              {i < item.tests.length - 1 && ", "}
            </span>
          ))
        ) : (
          <em>No Tests</em>
        )}
      </td>

      <td>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            handlePrintReport(item);
          }}
          className="btn btn-info btn-sm me-2"
        >
          <i className="ri-download-fill fs-16"></i>&nbsp;Print
        </button>

        {/* Hidden Edit and Delete buttons */}
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            sessionStorage.setItem("tst_dt", JSON.stringify(item));
            window.location.href = "/report_entry";
          }}
          className="btn btn-warning btn-sm me-2 d-none"
            disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
        >
          <i className="ri-pencil-fill fs-16"></i>&nbsp;Edit
        </button>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            delItem(item);
          }}
          className="btn btn-danger btn-sm d-none"
            disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
        >
          <i className="ri-delete-bin-5-fill fs-16"></i>&nbsp;Delete
        </button>
      </td>
    </tr>
  ))
) : (
  <tr>
    <td colSpan={8} style={{ textAlign: "center" }}>
      No Records Found
    </td>
  </tr>
)}

</tbody>

                                    </table>
                                        {/* <div class="noresult">
                                            <div class="text-center">
                                                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                                                <h5 class="mt-2">Sorry! No Result Found</h5>
                                                <p class="text-muted">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div class="d-flex justify-content-end">
                                        <div class="pagination-wrap hstack gap-2">
                                            <a class="page-item pagination-prev disabled" href="javascript:void(0)"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (formData.page_no > 0) {
                                                        formData.page_no--;
                                                        initData();
                                                    }
                                                }}
                                            >Previous</a>
                                            <ul class="pagination listjs-pagination mb-0"></ul>
                                            <a class="page-item pagination-next" href="javascript:void(0)"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    formData.page_no++;
                                                    initData();
                                                }}
                                            >Next</a>
                                        </div>
                                    </div>
                                </div>
                                <DelBox />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      
    );
};

export default TestParams;
